import type { ApplicationType } from '@xing-com/crate-jobs-helpers';

export const applicationTypeNwtContext: Record<ApplicationType, string> = {
  EmailApplication: 'email_apply',
  JobXingApplication: 'instant_apply',
  MessageApplication: 'private_message_apply',
  UrlApplication: 'url_apply',
  EasyApplication: '',
};
